export default __webpack_public_path__ + "static/media/logotylo.e07f58da.png";